import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../../react-commons/components/control-flow/Show';
import type { FormNames } from '../../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    StandardPropertyValidation,
    type StandardResource,
} from '../../../../../resource/resources/artifacts/standard/standardResource';
import { PropertyInputs } from '../../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const StandardContent = ({
    id,
    form,
    formNames,
    readOnly,
    displayedInOverview,
}: {
    id?: string;
    form: UseFormReturn<StandardResource>;
    formNames: FormNames<StandardResource>;
    readOnly: boolean;
    displayedInOverview?: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: StandardPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.STANDARD,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Show when={!displayedInOverview}>
                <Grid.Col span={12}>
                    <PropertyInputs.Name
                        name={formNames.name}
                        control={form.control}
                        readOnly={readOnly}
                        propertyValidationInformation={getPropertyValidationInformation(
                            StandardPropertyValidation.NAME
                        )}
                    />
                </Grid.Col>
            </Show>
            <Grid.Col span={12}>
                <PropertyInputs.MultilineString
                    name={formNames.description}
                    nullable={false}
                    control={form.control}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        StandardPropertyValidation.DESCRIPTION
                    )}
                />
            </Grid.Col>
        </Grid>
    );
};
